export enum WheelColor {
    RED = 'red',
    WHITE = 'white',
    GREY = 'grey',
    BLACK = 'black',
    // Numbers options
    BLUE = 'blue',
}
